// extracted by mini-css-extract-plugin
module.exports = {"inactive":"active_inactive__loYKA","inline":"active_inline__7peXj"};